var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youTube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.291,
    height: 17.914,
    viewBox: "0 0 25.291 17.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Youtube-2",
    "data-name": "Youtube",
    d: "M210.034,380.261V373.1l6.834,3.59Zm15-8.4a5.535,5.535,0,0,0-1.005-2.528,3.6,3.6,0,0,0-2.534-1.079c-3.539-.258-8.848-.258-8.848-.258h-.011s-5.309,0-8.848.258a3.6,3.6,0,0,0-2.534,1.079,5.531,5.531,0,0,0-1,2.528,38.808,38.808,0,0,0-.253,4.122v1.933a38.777,38.777,0,0,0,.253,4.122,5.531,5.531,0,0,0,1,2.528,4.269,4.269,0,0,0,2.789,1.089c2.023.2,8.6.256,8.6.256s5.314-.008,8.853-.266a3.6,3.6,0,0,0,2.534-1.079,5.534,5.534,0,0,0,1.005-2.528,38.773,38.773,0,0,0,.253-4.122v-1.933a38.8,38.8,0,0,0-.253-4.122Z",
    transform: "translate(-200 -368)",
    fill: "#ce1312",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubePlan);
export default __webpack_public_path__ + "static/media/youTube-plan.7827735a45b2dc5eb957313d0d7d0a83.svg";
export { ForwardRef as ReactComponent };